"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    navItemVariants: ()=>navItemVariants
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const navItemVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        content: 'text-neutral-11 hover:bg-neutral-3 flex items-center gap-2 rounded-md px-4 py-2 text-sm transition-colors',
        iconSlot: 'text-neutral-8 shrink-0',
        textContentSlot: 'w-full min-w-0 truncate'
    },
    variants: {
        active: {
            true: {
                content: 'bg-primary-3 text-primary-11 hover:bg-primary-4 font-medium',
                iconSlot: 'text-primary-12'
            }
        },
        disabled: {
            true: {
                content: 'pointer-events-none opacity-50'
            }
        },
        isCollapsibleTrigger: {
            true: {
                content: 'mb-1 hover:bg-transparent'
            }
        }
    },
    defaultVariants: {
        active: false,
        disabled: false
    }
});
exports.navItemVariants = __webpack_exports__.navItemVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "navItemVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
